import { render, staticRenderFns } from "./DialogParticipants.vue?vue&type=template&id=449db76a&scoped=true&"
import script from "./DialogParticipants.vue?vue&type=script&lang=js&"
export * from "./DialogParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449db76a",
  null
  
)

export default component.exports